module.exports = __webpack_public_path__ + "img/jp_xhs.a618424.png";